<script>
    import {formatTimestamp} from '../../..//Utilities/time_format';
    import {session, userMap} from '../../../Utilities/Session.svelte';
    import FormModal from '../../../Forms/FormModal.svelte';
    import {confirm} from '../../Confirmation.svelte';
    import NoteTags from '../../NoteTags.svelte'
    import {clean} from '../../../Utilities/Cleaner.svelte';
    import markdown from '../../../Utilities/markdown';

    export let library_item;
    export let assessment;

    import Fa from 'svelte-fa';
    import {faPencil} from "@fortawesome/free-solid-svg-icons";

    let tags = [];
    let showFormModal;

    function editNote(note) {
        showFormModal = {
            fields: [{
                name: "tags",
                type: "custom",
                component: NoteTags,
                componentProps: {
                    comment_tags: [...assessment.assessment_type_data.comment_tags, ...assessment.comment_tags.tags]
                }
            },{
                name: "note",
                label: "Note",
                type: "textarea",
                required: true
            }],
            title: "Edit Note",
            data: note,
            showDelete: true,
            cancelAction: () => showFormModal = undefined,
            saveAction: (note) => {
                assessment.model.updateLibraryNote(note);
                showFormModal = undefined
            },
            deleteAction: () => {
                confirm("Are you sure you want to delete this note?").then(() => {
                    assessment.model.deleteLibraryNote(note);
                    showFormModal = undefined
                }).catch(err => {});
            }
        }
    }

    function submitNote(evt) {
        let note_text = evt.target.note.value;

        if (!note_text) return;

        let note_tags = tags;

        assessment.model.addLibraryNote(library_item.item_id, note_text, note_tags);

        //reset form
        tags = [];
        evt.target.reset();
        evt.target.note.focus();
    }

    function handleEnter(evt) {
        if (evt.keyCode == 13) {
            if (evt.altKey) {
                evt.target.value += "\r\n";
            } else {
                submitNote({
                    target: evt.target.form
                });
                evt.preventDefault();
                return false;
            }
        }
    }
</script>

 <h3 class="title is-5">Notes</h3>
{#if assessment.library_notes[library_item.item_id]}
    {#each assessment.library_notes[library_item.item_id] as note (note._id)}
        <article class="media">
            <div class="media-content">
                <div class="content">
                    <p class="comment is-size-6">
                        <strong>{$userMap[note.user] || note.user}</strong>
                        <small>
                            {#if note.ts}
                                {formatTimestamp(note.ts)}
                            {:else}
                                {note.timestamp}
                            {/if}
                            {#if $session.user.email == note.user}
                                <span class="icon pointer" on:click={() => editNote(note)}>
                                    <i><Fa icon={faPencil} /></i>
                                </span>
                            {/if}
                        </small>
                        <span class="tags">
                            {#each note.tags || [] as tag}
                                <span class="tag is-{tag.color_class}">{tag.name}</span>
                            {/each}
                        </span>
                        <span class="note">{@html clean(markdown(note.note))}</span>
                    </p>
                </div>
            </div>
        </article>
    {/each}
    <hr>
{/if}

<form on:submit|preventDefault={submitNote}>
    <input name="control_id" type="hidden" value="{library_item.item_id}">
    <NoteTags bind:value={tags} comment_tags={[...(assessment.assessment_type_data.comment_tags || []), ...assessment.comment_tags.tags]}></NoteTags>
    <div class="field">
        <div class="control">
            <textarea class="textarea" name="note" on:keydown={handleEnter}></textarea>
            <span class="is-pulled-left is-size-6 markdown-help">
                *<strong>bold</strong>* _<em>italics</em>_ ~<s>strikethrough</s>~ #<mark>highlight</mark>#
            </span>
        </div>
    </div>

    <div class="buttons is-right">
        <button class="button is-right">Save</button>
    </div>
</form>

{#if showFormModal}
    <FormModal {...showFormModal}></FormModal>
{/if}

<style>
    .tag.pointer {
        user-select: none;
    }
    .note {
        margin-top: .25rem;
    }

    .tags {
        margin-bottom: 0;
    }
</style>